import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, costFormater, Text, useResponsive } from '@common-fe/common-fe';
import _ from 'lodash';

import { useGetFundIcon } from '@/modules/investments/hooks';
import { FundPayload } from '@/modules/investments/SelfDirected/SelfDirected.types';

import { PERCENTS_LIQUIDATION_LIMIT } from '../Funds.constants';

interface Props extends FundPayload {
  value: number;
  testId?: string;
}
const ConfirmModalItem: React.FC<Props> = ({ testId, title, stockCode, status, logo, value, amount = 0 }) => {
  const { t } = useTranslation();
  const { isMobile } = useResponsive();
  const isLiquidation = useMemo(() => {
    const percents = value / amount;
    if (_.isNaN(percents)) {
      return false;
    }
    return percents >= PERCENTS_LIQUIDATION_LIMIT;
  }, [amount, value]);

  const handleGetFundIcon = useGetFundIcon();
  return (
    <Box
      direction="column"
      pad={{ vertical: '12px', horizontal: 'l' }}
      background="canvas"
      round="container2Round"
      border={{ size: 'small', color: 'border1' }}
      margin={{ top: 'xs' }}
    >
      <Box direction="row" align="center">
        <Box style={{ zIndex: 10000 }}>
          {handleGetFundIcon({
            image: logo,
            status,
          })}
        </Box>
        <Box
          margin={{ left: 's' }}
          style={{
            flex: 2,
            position: 'relative',
          }}
          direction="column"
        >
          <Box width="100%">
            <Text data-testid={`${testId}_title`} tip={title} truncate weight={700}>
              {title}
            </Text>
            <Text data-testid={`${testId}_stock`}>{stockCode}</Text>
          </Box>
        </Box>
        <Box direction="row" justify="between" margin={{ left: 's' }} style={isMobile ? {} : { flex: 2 }}>
          <Text weight={700} data-testid={`${testId}_value`}>
            {costFormater(value, { isPrecision: true })}
          </Text>
          {isLiquidation && !isMobile && <Text color="danger">{t('Full position liquidation')}</Text>}
        </Box>
      </Box>
      {isLiquidation && isMobile && (
        <Text color="danger" margin={{ top: 'spacing8' }}>
          {t('Full position liquidation')}
        </Text>
      )}
    </Box>
  );
};

export default ConfirmModalItem;
